import { on } from "events";
import { Check, CircleAlert, View } from "lucide-react";
import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { validateEmail } from "../../uiHelpers";
import { AppCustomPropertyError } from "./AppCustomPropertyError";
import { ShortSettings } from "./customPropertyConfig";

type AppCustomPropertyShortProps = {
    customProperty: CustomProperty;
    data: any;
    disabled: boolean;
    validate: boolean;
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyShort = ({customProperty, data, disabled, validate, onChange} : AppCustomPropertyShortProps) => {

    const [value, setValue] = useState<string>(data as string || "");

    const settings = JSON.parse(customProperty.settings || "{}") as ShortSettings;

    useEffect(() => {
        if (data && data !== value) {
            setValue(data as string)
        }
    }, [data]);

    if (customProperty.label === "system-firstName" && !data) {
        console.log("[AppCustomPropertyShort] empty data: ", data);
        // alert ("empty data");
    }

    return (
        <div className="app-custom-property-short">
            {/* <div className="app-custom-property-label">
                {customProperty.label}
            </div> */}
            <div className="app-custom-property-value"> 
                <input 
                    type="text"
                    value={value}
                    disabled={disabled}
                    onChange={(event) => {
                        setValue(event.target.value);
                        onChange(customProperty.label, event.target.value);
                    }}
                    maxLength={settings?.maxCharsOn ? settings?.maxChars : undefined}
                />
                <AppCustomPropertyError 
                    flagRequired={validate && !value && customProperty.required}
                />
                {/* {validate && !value && customProperty.required &&
                    <div className="app-employee-record-error">
                        <Check size={16} color="red"/>
                    </div>
                }  */}
            </div>
        </div>
    )
}
